module.exports = __webpack_public_path__ + "static/media/parental_cover.1e7f5c48.svg";